import { z } from 'zod'

// Supports JS dates and any parseable date string. Deliberately looser than a
// strict `...Z` regex: Supabase returns timestamps like
// `2026-07-20T16:59:00.123456+00:00`, and edit forms round-trip those rows.
const hybridDateSchema = z.union([
  z.date(),
  z.string()
    .refine(str => !Number.isNaN(new Date(str).getTime()), {
      message: 'Invalid ISO date format',
    })
    .transform(str => new Date(str)),
])

export const depositSchema = z.object({
  id: z.coerce.number().optional(),
  business_id: z.string().uuid(),

  // Nullable: a deposit can be global (no shift) or drawer-linked.
  shift_id: z.coerce.number().positive('Shift ID must be a positive number').optional().nullable(),

  // Money source the deposit goes into - references fund_sources.id.
  // Required from day one (deposits are new; no legacy-null rule like expenses).
  fund_source_id: z.coerce.number().positive('Please select a valid fund source'),

  amount: z.coerce.number().positive('Amount must be greater than zero'),
  notes: z.string().optional().nullable(),
  deposit_date: hybridDateSchema.optional(),
  created_at: hybridDateSchema.optional(),
  created_by: z.string().uuid().optional().nullable(),
})

export const updateDepositSchema = z.object({
  // Optional: the PUT endpoint takes identity from the URL and strips any body id.
  id: z.coerce.number().optional(),
  business_id: z.string().uuid(),
  shift_id: z.coerce.number().positive('Shift ID must be a positive number').optional().nullable(),
  fund_source_id: z.coerce.number().positive('Please select a valid fund source'),
  amount: z.coerce.number().positive('Amount must be greater than zero'),
  notes: z.string().optional().nullable(),
  deposit_date: hybridDateSchema.optional(),
})

export type Deposit = z.infer<typeof depositSchema>
